import type { ButtonHTMLAttributes, ReactNode } from "react";

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
  variant?: "primary" | "secondary" | "ghost";
  size?: "sm" | "md";
  icon?: ReactNode;
  children: ReactNode;
}

export function Button({
  children,
  variant = "primary",
  size = "md",
  icon,
  className,
  ...rest
}: Props) {
  return (
    <button
      type="button"
      className={`bbc-btn bbc-btn-${variant} bbc-btn-${size} ${className ?? ""}`.trim()}
      {...rest}
    >
      {icon && <span className="bbc-btn-icon">{icon}</span>}
      {children}
    </button>
  );
}
